"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var AXSBlock_1 = __importDefault(require("../../layout/AXSBlock/AXSBlock"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var utils_1 = require("../../utils");
var colors_1 = require("../../constants/colors");
var AXSFlex_1 = __importDefault(require("../../layout/AXSFlex"));
var helpers_1 = require("../../helpers");
var Wrapper = styled_components_1.default(AXSBlock_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-radius: 100%;\n    border: ", ";\n    cursor: ", ";\n    height: ", ";\n    padding: 3px;\n    width: ", ";\n"], ["\n    border-radius: 100%;\n    border: ",
    ";\n    cursor: ", ";\n    height: ", ";\n    padding: 3px;\n    width: ", ";\n"])), function (_a) {
    var active = _a.active, theme = _a.theme;
    return active ?
        "2px solid " + utils_1.parseThemePath('axsui.components.avatar.borderColor', theme, '#007def') :
        '2px solid transparent';
}, function (_a) {
    var customerString = _a.customerString;
    return !customerString ? 'pointer' : 'default';
}, function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var size = _a.size;
    return size;
});
var Avatar = styled_components_1.default(AXSFlex_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background-color: ", ";\n    background-image: ", ";\n    background-position: center center;\n    background-size: cover;\n    border-radius: 100%;\n    border-style: solid;\n    color: ", ";\n\n    line-height: ", ";\n    width: 100%;\n    height: 100%;\n"], ["\n    background-color: ",
    ";\n    background-image: ", ";\n    background-position: center center;\n    background-size: cover;\n    border-radius: 100%;\n    border-style: solid;\n    color: ",
    ";\n\n    line-height: ", ";\n    width: 100%;\n    height: 100%;\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor, backgroundColorDisabled = _a.backgroundColorDisabled, disabled = _a.disabled, theme = _a.theme;
    return disabled
        ? utils_1.parseThemePath(backgroundColorDisabled, theme, colors_1.colors.GREY_250)
        : utils_1.parseThemePath(backgroundColor, theme, colors_1.colors.BLUE_300);
}, function (_a) {
    var url = _a.url;
    return url ? "url(" + url + ")" : 'none';
}, function (_a) {
    var color = _a.color, colorDisabled = _a.colorDisabled, disabled = _a.disabled, theme = _a.theme, customerString = _a.customerString;
    return disabled
        ? utils_1.parseThemePath(colorDisabled, theme, colors_1.colors.WHITE)
        : utils_1.parseThemePath(customerString ? colors_1.colors.WHITE : color, theme, colors_1.colors.WHITE);
}, function (_a) {
    var fontSize = _a.fontSize;
    return fontSize;
});
var ContentWrapper = styled_components_1.default(AXSBlock_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: table-cell; // Better vertical alignment;\n  font-size: ", ";\n  font-weight: bold;\n  vertical-align: middle;\n  user-select: none;\n"], ["\n  display: table-cell; // Better vertical alignment;\n  font-size: ", ";\n  font-weight: bold;\n  vertical-align: middle;\n  user-select: none;\n"])), function (_a) {
    var fontSize = _a.fontSize;
    return fontSize;
});
var AXSAvatar = function (_a) {
    var children = _a.children, backgroundColor = _a.backgroundColor, borderRadius = _a.borderRadius, borderColor = _a.borderColor, borderWidth = _a.borderWidth, color = _a.color, customerString = _a.customerString, size = _a.size, className = _a.className, padding = _a.padding, colorDisabled = _a.colorDisabled, active = _a.active, backgroundColorDisabled = _a.backgroundColorDisabled, borderColorDisabled = _a.borderColorDisabled, disabled = _a.disabled, url = _a.url, radius = _a.radius, props = __rest(_a, ["children", "backgroundColor", "borderRadius", "borderColor", "borderWidth", "color", "customerString", "size", "className", "padding", "colorDisabled", "active", "backgroundColorDisabled", "borderColorDisabled", "disabled", "url", "radius"]);
    return (React.createElement(Wrapper, __assign({}, props, { customerString: customerString, borderColor: borderColor, size: radius ? radius : size, active: active }),
        React.createElement(Avatar, { alignContent: "center", alignItems: "center", backgroundColor: customerString ? helpers_1.convertStringToColor(customerString) : backgroundColor, borderRadius: borderRadius, borderWidth: borderWidth, className: classnames_1.default(['c-axs-avatar', className]), color: color, disabled: disabled, backgroundColorDisabled: backgroundColorDisabled, borderColorDisabled: borderColorDisabled, colorDisabled: colorDisabled, customerString: customerString, inline: true, justifyContent: "center", url: url }, !url ? React.createElement(ContentWrapper, { backgroundColor: "transparent" }, children) : null)));
};
AXSAvatar.defaultProps = {
    backgroundColor: 'axsui.components.avatar.backgroundColor',
    backgroundColorDisabled: 'axsui.components.avatar.backgroundColorDisabled',
    borderColor: 'axsui.components.avatar.borderColor',
    borderColorDisabled: 'axsui.components.avatar.borderColorDisabled',
    borderWidth: 'axsui.components.avatar.borderWidth',
    color: 'axsui.components.avatar.color',
    colorDisabled: 'axsui.components.avatar.colorDisabled',
    fontSize: '18px',
    size: '64px',
};
exports.default = AXSAvatar;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map